import { Flex, FlexProps, useDisclosure } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { ConfirmModal } from "design_system/components/Modal";
import { OFText } from "design_system/components/OFText";
import { ToggleCheckbox } from "design_system/components/Toggle";
import getNameProp from "src/utils/getNameProp";

type Props = FlexProps & {
  isAutoRefill: boolean;
  onToggle: () => void;
  isShowConfirmation?: boolean;
  disabled?: boolean;
};

const AutoRefillToggle = ({
  isAutoRefill,
  onToggle,
  isShowConfirmation,
  disabled,
  ...props
}: Props) => {
  const { t } = useTranslation(["plan", "common", "meds_selection"]);

  const confirmModalTransPath = `common:modal.auto_renew_confirm.${
    isAutoRefill ? "manual" : "auto"
  }`;
  const btnTransPath = "common:modal.button";

  const { isOpen: isOpenConfirm, onClose: onCloseConfirm, onOpen: onOpenConfirm } = useDisclosure();

  const handleToggle = () => {
    if (isShowConfirmation) {
      onOpenConfirm();
    } else {
      onToggle();
    }
  };

  return (
    <>
      <Flex justify="space-between" align="center" {...props}>
        <Flex flexDir="column" mt={3} mr={3}>
          <Flex align="center">
            <OFText textStyle="body1">
              {t("meds_selection:section.auto_refill.toggle_title")}
            </OFText>
          </Flex>
          <OFText textStyle="body3">
            {t(`renewal_mode.desc.${isAutoRefill ? "on" : "off"}`, {
              defaultValue: ""
            })}
          </OFText>
        </Flex>

        <ToggleCheckbox
          isChecked={isAutoRefill}
          onChange={handleToggle}
          disabled={disabled}
          {...getNameProp("plan-auto-renewal-switch")}
        />
      </Flex>

      <ConfirmModal
        isOpen={isOpenConfirm}
        onClose={onCloseConfirm}
        onConfirmClick={() => {
          onToggle();
          onCloseConfirm();
        }}
        confirmText={t(`${btnTransPath}.confirm`)}
        title={t(`${confirmModalTransPath}.title`)}
        body={t(`${confirmModalTransPath}.description`)}
        isHideCancel
      />
    </>
  );
};

export default AutoRefillToggle;
